<script setup>
defineProps({
  title: {
    type: String,
    required: true,
  },
  text: {
    type: Array,
    required: true,
  },
  isAddition: {
    type: Boolean,
    default: false,
  },
});
</script>

<template>
  <div
    class="content-disclaimer"
    :class="{ 'content-disclaimer--addition': isAddition }"
  >
    <div class="content-disclaimer__inner">
      <div class="content-disclaimer__title">{{ title }}</div>
      <PostContent
        :content="text"
        :is-disclaimer="!isAddition"
        :is-addition="isAddition"
      />
    </div>
  </div>
</template>

<style scoped lang="postcss">
.content-disclaimer {
  max-width: var(--content-max-width);
  margin: 40px auto;

  &__inner {
    position: relative;
    z-index: 1;
    padding: 24px;

    &::before {
      content: '';
      position: absolute;
      z-index: -1;
      top: 0;
      left: 50%;
      width: 100%;
      height: 100%;
      transform: translateX(-50%);
      border-radius: 24px;
      background: var(--disclaimer-gradient);
      opacity: 0.6;
    }
  }

  &__title {
    font-size: var(--h5-font-size);
    line-height: var(--h5-line-height);
    font-weight: 700;
    color: var(--title-light-color);
    font-family: var(--body-font-family);
  }

  &--addition {
    .content-disclaimer__inner {
      word-break: break-word;

      &::before {
        background: #f1e2ef;
      }
    }

    .content-disclaimer__title {
      color: var(--black-color);
    }
  }

  @media (--small-vp) {
    margin: 16px auto;

    &__inner {
      padding: 12px;

      &::before {
        border-radius: 16px;
      }
    }

    &__title {
      margin-bottom: -4px;
      font-size: 16px;
      line-height: 20px;
    }
  }
}
</style>
